/* eslint-disable no-console */
/**
 * Snackbar Controller Servoce must be initialized before use
 * Web initialization: useWebInitAlert()
 */

import { ISnackbarHandler, ISnackbarHandlerProps } from './types';

class SnackbarController {
  private snackbarHandler?: ISnackbarHandler | null;

  public showAlert = (params: ISnackbarHandlerProps) => {
    if (!this.snackbarHandler) {
      console.warn('SnackbarHandler must be set before showing snackbar');
      return;
    }
    this.snackbarHandler.alert(params);
  };

  public setSnackbarHandler = (snackbarHandler: ISnackbarHandler) => {
    this.snackbarHandler = snackbarHandler;
  };
}

const snackbarController = new SnackbarController();

export default snackbarController;
